import { useContext } from "react"
import ThemeContext from "../context/ThemeContext"

export const getCustomTheme = () => {
  const theme = localStorage.getItem("publicKBTheme")
  return theme ? JSON.parse(theme) : null
}

export const useTheme = () => {
  const { setTheme } = useContext(ThemeContext)

  const handleSetTheme = (theme) => {
    // Set the user customized kb page here from the KB data
    // they've set in the backend.
    localStorage.setItem("publicKBTheme", JSON.stringify(theme))
    setTheme(theme)
  }

  const setCustomTheme = (publicKB) => {
    // We can set the theme in local storage here,
    // we will have to compare the theme in local storage with
    // the theme in the context if it has changed then we
    //  will update the theme in local storage
    const currentTheme = getCustomTheme()
    const theme = {
      headerTextColor: publicKB.header_text_color,
      primaryColor: publicKB.primary_color,
      customStyles: publicKB.styles,
      headerText: publicKB.header_text,
      title: publicKB.company?.company_name || "",
    }

    if (currentTheme) {
      if (JSON.stringify(currentTheme) !== JSON.stringify(theme)) {
        handleSetTheme(theme)
      }
    } else {
      handleSetTheme(theme)
    }
  }

  return { setCustomTheme }
}
